'use client';

import { useTranslation } from '@/contexts/TranslationContext';
import Link from 'next/link';
import Header from '@/components/Header';
import TermsAndConditionsContent from '@/components/TermsAndConditionsContent';

export default function TermsAndConditionsPage() {
  const { t, loading } = useTranslation();
  const currentYear = new Date().getFullYear();

  // Show loading state while translations are being loaded
  if (loading) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto mb-4" role="status" aria-label="Loading">
            <span className="sr-only">Loading...</span>
          </div>
          <p className="text-gray-600">Loading...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50">
      <Header />
      
      <div className="pt-20 pb-12">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          {/* Botón Volver al inicio - fuera del nav bar */}
          <div className="mb-8">
            <Link
              href="/"
              className="text-blue-600 hover:text-blue-800 mb-4 flex items-center space-x-2 cursor-pointer"
              aria-label={t("pages.backToHome")}
            >
              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
              </svg>
              <span>{t("pages.backToHome")}</span>
            </Link>
          </div>
          
          <TermsAndConditionsContent />
        </div>
      </div>

      {/* Footer */}
      <footer className="bg-white border-t border-gray-200" role="contentinfo">
        <div className="max-w-7xl mx-auto py-6 px-4 sm:px-6 lg:px-8">
          <div className="text-center text-gray-600 text-sm">
            <p>{t('footer.copyright', { year: currentYear })}</p>
          </div>
        </div>
      </footer>
    </div>
  );
}